"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const insurances = ["Médis", "Médis CTT", "Multicare", "Amut", "Medicare", "Agilidade", "Advancecare", "Dental Rede", "Oftalmed", "Saúde Particular", "Future Health Care"];
export default function SeguradorasEAcordos() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="seguradoras-e-acordos" className="bg-muted py-16 md:py-24">
      <div ref={ref} className={`container mx-auto px-4 md:px-8 max-w-5xl transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">
            Seguradoras e Acordos
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Trabalhamos com as principais seguradoras para garantir o acesso aos melhores cuidados de saúde.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-6">
          {insurances.map((insurance, index) => <div key={insurance} data-index={index} className="bg-background px-6 py-3 rounded-lg shadow-sm border border-border/50 text-foreground font-medium text-base md:text-lg transition-all duration-300 hover:text-secondary hover:shadow-md hover:-translate-y-0.5 cursor-default flex items-center justify-center select-none">
              {insurance}
            </div>)}
        </div>
      </div>
    </section>;
}